import { Alert, Button, Modal } from 'antd';
import React from 'react';
import StyledContent from './styled';

const SuccessModal = ({ setVisible, visible }) => {
  const handleCancel = () => {
    setVisible(false);
  };

  const driverInvoicingStatusReportUrl = 'https://lookerstudio.google.com/u/0/reporting/0734015e-2923-4ba9-ace5-f6de006fd29b/page/p_wsms27hbdd';

  return (
    <Modal visible={visible} width="500px" footer={null} onCancel={handleCancel}>
      <StyledContent>
        <h3>Invoicing Started</h3>

        <p>The uploaded file is being processed. The invoices will be generated and sent to the drivers.</p>

        <Alert type="warning" message={
          <>This will take some time and the progress can be tracked <a href={driverInvoicingStatusReportUrl} target="_blank">here</a>.</>
        }/>
        <br/>

        <Button key="submit" type="primary" onClick={handleCancel}>
          Done
        </Button>
      </StyledContent>
    </Modal>
  );
};

export default SuccessModal;
